/**
 * brand-logo — tiny module store for the active Marca logo URL.
 *
 * Compatible with useSyncExternalStore.
 * Set by BrandThemeLoader alongside applyBrandTheme whenever auth state changes.
 * Default: null (no logo → nothing renders).
 */

let _url: string | null = null;
const _listeners = new Set<() => void>();

/** Returns the current Marca logo URL, or null when unset. */
export function getBrandLogoUrl(): string | null {
  return _url;
}

/** Updates the stored URL and notifies all subscribers. */
export function setBrandLogoUrl(url: string | null): void {
  if (_url === url) return;
  _url = url;
  _listeners.forEach((cb) => cb());
}

/** Subscribe to store changes. Returns an unsubscribe function. */
export function subscribe(callback: () => void): () => void {
  _listeners.add(callback);
  return () => {
    _listeners.delete(callback);
  };
}
